import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';
import withAddToBasketAjaxCallWrapper from './hocComponents/withAddToBasketAjaxCallWrapper';
import AddToBasketButton from './presentionalComponents/AddToBasketButton';
import { PSA_SWITCHED_OFF } from '../PopupStyleAttach/components/PSAPopup/PSAPopup';


export default function AddToBasketButtonWithAjaxCall(props) {
  const randomButtonId = useRef(String(Math.random()));
  const EnhancedAddToBasketButton = withAddToBasketAjaxCallWrapper(
    ({
      thisButtonId,
      loadingButtonId,
      addToBasket,
      storeTokenIsLoading
    }) => (
      <AddToBasketButton
        buttonLabel={props.buttonLabel}
        full={props.full}
        download={props.download}
        disabled={!!loadingButtonId || !!storeTokenIsLoading}
        showSpinner={thisButtonId === loadingButtonId}
        onClick={(e) => {
          props.beforeAddingToBasket();
          addToBasket();
          if (e.preventDefault) {
            e.preventDefault();
          } else {
            e.returnValue = false;
          }
        }}
      >
        {props.render
          ? props.render({
            isLoading: thisButtonId === loadingButtonId,
            ...props
          })
          : props.children}
      </AddToBasketButton>
    )
  );

  return (
    <EnvironmentThemeProvider>
      <EnhancedAddToBasketButton
        fupid={props.fupid}
        quantity={props.quantity}
        deliverySlotLabel={props.deliverySlotLabel}
        deliverySlotPrice={props.deliverySlotPrice}
        deliverySlotId={props.deliverySlotId}
        deliverySlotPostCode={props.deliverySlotPostCode}
        deliverySlotDate={props.deliverySlotDate}
        sameDayDelivery={props.sameDayDelivery}
        storeId={props.storeId}
        deliveryType={props.deliveryType}
        visitorId={props.visitorId}
        mainProductId={props.mainProductId}
        mainProductSegmentId={props.mainProductSegmentId}
        addonProductsIds={props.addonProductsIds}
        addonProductsNames={props.addonProductsNames}
        addonProductsSegmentIds={props.addonProductsSegmentIds}
        bundlePrice={props.bundlePrice}
        wasAddedFromWishlist={props.wasAddedFromWishlist}
        thisButtonId={randomButtonId.current}
        psaVariant={props.psaVariant}
        buttonPlacementID={props.buttonPlacementID}
      />
    </EnvironmentThemeProvider>
  );

}

AddToBasketButtonWithAjaxCall.propTypes = {
  fupid: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  deliverySlotLabel: PropTypes.string, // For MCD Delivery Slot
  deliverySlotPrice: PropTypes.string, // For MCD Delivery Slot
  deliverySlotId: PropTypes.string, // For MCD Delivery Slot
  deliverySlotPostCode: PropTypes.string, // For MCD Delivery Slot
  deliverySlotDate: PropTypes.string, // For REGULAR MCD Delivery Slot
  sameDayDelivery: PropTypes.string, // For Same Day Delivery MCD Delivery Slot
  storeId: PropTypes.number, // For RnC and PnC collections
  deliveryType: PropTypes.oneOf(['RESERVE_AND_COLLECT', 'PAY_AND_COLLECT', 'PAY_AND_COLLECT_FROM_STORE_STOCK']), // For RnC, PnCSS and PnC collections
  visitorId: PropTypes.string, // For Syntasa bundles
  mainProductId: PropTypes.string, // For PSA - attachments to be loaded for main product
  mainProductSegmentId: PropTypes.number, // For attachments filter - same product category to be filtered from attachments
  addonProductsIds: PropTypes.arrayOf(PropTypes.string), // accessory products for dynamic bundle,
  addonProductsNames: PropTypes.arrayOf(PropTypes.string), // accessory products names dynamic bundle,
  addonProductsSegmentIds: PropTypes.arrayOf(PropTypes.number), // accessory products categories for dynamic bundle,
  bundlePrice: PropTypes.number, // bundle price dynamic bundle
  wasAddedFromWishlist: PropTypes.bool, // flag it it was added from wishlist
  buttonLabel: PropTypes.string,
  full: PropTypes.bool,
  download: PropTypes.bool,
  beforeAddingToBasket: PropTypes.func,
  psaVariant: PropTypes.string,
  render: PropTypes.func,
  children: PropTypes.node,
  buttonPlacementID: PropTypes.string
};

AddToBasketButtonWithAjaxCall.defaultProps = {
  deliverySlotLabel: undefined,
  deliverySlotPrice: undefined,
  deliverySlotId: undefined,
  deliverySlotPostCode: undefined,
  deliverySlotDate: undefined,
  sameDayDelivery: undefined,
  storeId: undefined,
  deliveryType: undefined,
  visitorId: undefined,
  mainProductId: undefined,
  mainProductSegmentId: undefined,
  addonProductsIds: undefined,
  addonProductsNames: undefined,
  addonProductsSegmentIds: undefined,
  bundlePrice: undefined,
  wasAddedFromWishlist: undefined,
  buttonLabel: 'No Label',
  full: true,
  download: false,
  beforeAddingToBasket: () => {},
  psaVariant: PSA_SWITCHED_OFF,
  render: undefined,
  children: undefined,
  buttonPlacementID: 'default'
};

